import React, { Component } from 'react';
import { Link } from "react-router";
import { connect } from "react-redux";
import _ from 'underscore';
import { setSettingsToggle, logoutUser } from '../../actions/userActions';
import { toggleSettings, modalController } from '../../actions/domActions';
import sentry from '../../utils/sentry';
import apiUrls from '../../urls';

// SASS Imports
require('./Settings.scss');

function mapStateToProps (state, ownProps) {
    return {
        user: state.user,
        api: state.api,
        settings: state.settings,
        isSettingsOpen: state.dom.isSettingsOpen
    };
}

function mapDispatchToProps (dispatch, ownProps) {
    return {
        setSettingsToggle: (k, v) => dispatch(setSettingsToggle(k, v)),
        logoutUser: () => dispatch(logoutUser()),
        closeSettings: () => dispatch(toggleSettings(true)),
        modalController: (currentModal, isSettingsOpen) => {
            dispatch(modalController(currentModal));
            dispatch(toggleSettings(isSettingsOpen));
        }
    };
}

class Settings extends Component {
    constructor (props) {
        super(props);

        this.onClickOutside = this.onClickOutside.bind(this);
    }

    saveToggle (name, value) {
        if (this.props.settings[name] !== value) {
            this.props.api.saveUserPreferences({
                ...this.props.settings,
                [name]: value
            })
                .then((response) => null) // o...k?
                .catch((error) => sentry.logException(error));

            this.props.setSettingsToggle(name, value);
        }
    }

    componentDidMount () {
        document.addEventListener('click', this.onClickOutside);
        document.body.classList.add('settingsIsOpen');
    }

    componentWillUnmount () {
        document.removeEventListener('click', this.onClickOutside);
        document.body.classList.remove('settingsIsOpen');
    }

    onClickOutside (e) {
        let current = e.target;
        let found = false;

        while (current.parentNode) {
            found = (current === this.refs.panel);
            if (found) {
                break;
            }
            current = current.parentNode;
        }

        if (!found) {
            this.props.closeSettings();
        }
    }

    onClickReportError () {
        this.props.modalController("REPORT_ERROR", this.props.isSettingsOpen);
    }

    // (tl;dr - don't remove the state update in the link below)
    // notice how we're passing in the api prop in the link below? if you look
    // at the Admin code, you'll see that it's never actually used. however! we
    // need it, because otherwise componentWillReceiveProps in Admin doesn't fire
    // we never make the API request, which means the interface never loads.
    // even better, we there's some magic happening in the react transpile, because
    // this ONLY WORKS when we pass in something from this.props. Giving it any old
    // junk doesn't trigger componentWillReceiveProps either.

    _renderAdminLink () {
        const user = this.props.user;

        if (user && user.timeTrackingRole === 'Administrator') {
            return (
                <li className="visible-lg">
                    <Link
                        onClick={() => this.props.closeSettings()}
                        to={{pathname: "/admin", state: {api: this.props.api}}}
                    >System Admin</Link>
                </li>
            );
        }
        return null;
    }

    _modalHandler (modal) {
        return this.props.modalController(modal, this.props.isSettingsOpen);
    }

    render () {
        const workingHoursString = _.chain(this.props.settings.workingHours)
            .zip(['MON','TUE','WED','THU','FRI','SAT','SUN'])
            .filter((day) => day[0].enabled)
            .map((day) => `${day[1]} (${Number(day[0].workingHours)})`)
            .value()
            .join(', ');

        const toggles = [{
            name: 'notifications',
            label: 'Turn Notifications Off/On'
        }, {
            name: 'confirmations',
            label: 'Turn Confirmations Off/On'
        }];

        return (
            <div ref="panel" className="settingsPanel">
                <div className="userInfo">
                    <h3 className="username">
                        { (this.props.user)
                            ? this.props.user.firstName + " " + this.props.user.lastName
                            : '' }
                    </h3>
                    <p className="email">
                        { (this.props.user) ? this.props.user.emailAddress : '' }
                    </p>
                </div>
                <ul className="settingsMenu">
                    {toggles.map((toggle) => (
                        <li>
                            <p>{toggle.label}</p>
                            <label className="toggleSwitch">
                                <input
                                    type="checkbox"
                                    defaultChecked={this.props.settings[toggle.name]}
                                    onChange={(e) => this.saveToggle(toggle.name, e.target.checked)}
                                />
                                <div className="slider round">
                                    {(this.props.settings[toggle.name]) ? 'ON' : 'OFF'}
                                </div>
                            </label>
                        </li>
                    ))}
                    <li>
                        <a onClick={() => this._modalHandler("EDIT_FAVORITES")}>
                            Edit My Favorites
                        </a>
                    </li>
                    <li>
                        <a onClick={() => this._modalHandler("WORKING_HOURS")}>
                            Working Hours <p className="currentWorkHours">
                                Currently Selected: {workingHoursString}
                            </p>
                        </a>
                    </li>
                    <li>
                        <a
                            href={process.env.SIGNIN_URL}
                            target="_blank"
                            onClick={() => this.props.closeSettings()}
                        >
                            Change Password
                        </a>
                    </li>
                    {this._renderAdminLink()}
                    {/*
                    <li>
                        <a href="/logout">Logout</a>
                    </li>
                    */}
                    <li>
                        <a onClick={() => this._modalHandler("REPORT_ERROR")}>Report a Bug or Issue</a>
                    </li>
                    <li>
                        <a onClick={() => this._modalHandler("ABOUT_TIME_TRACKER")}>
                            About Time Tracker
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);



// WEBPACK FOOTER //
// ./app/components/Settings/Settings.jsx